import proxy from "api/proxy";
import { getStorage, setStorage } from "store/local";

export async function fetchStaffConfiguration() {
  const localConfig = getStorage("staffConfig");
  if (localConfig) return localConfig;

  try {
    const { data } = await proxy.search(
      "staff.configuration",
      [],
      [
        "week_hours_work",
        "event_shift_limit",
        "change_shift_limit",
      ]
    );

    const config = data?.[0] ?? {
      week_hours_work: 42,
      event_shift_limit: 0,
      change_shift_limit: 0,
    };

    setStorage("staffConfig", config);
    return config;
  } catch (err) {
    console.error("Error fetching staff.configuration:", err);
    return {
      week_hours_work: 42,
      event_shift_limit: 0,
      change_shift_limit: 0,
    };
  }
}


export async function fetchWeekHoursWork() {
  const config = await fetchStaffConfiguration();
  return config.week_hours_work;
}

export function sectionsDomain() {
  const session = getStorage("ctxSession");
  return ["chiefs", "=", session?.user_employee];
}

export async function getSections() {
  const model = "staff.section";
  const fieldsNames = ["name"];
  const dom = [sectionsDomain()];
  const limit = 260;
  const { data } = await proxy.search(model, dom, fieldsNames, limit);
  return data;
}


export async function getPositions() {
  const model = "staff.position";
  const fieldsNames = ["id", "name"];
  const { data } = await proxy.search(model, [], fieldsNames);
  return data;
}

let cachedMealConsumptionMap = null;


export async function fetchMealConsumptionMap() {
  if (cachedMealConsumptionMap !== null) return cachedMealConsumptionMap;
  const map = new Map();
  try {
    const { data } = await proxy.search(
      "staff.meal",
      [],
      ["comsumption_time", "shift_kind"]
    );
    if (data && Array.isArray(data)) {
      for (const meal of data) {
        const mins = Number(meal.comsumption_time || 0);
        if (mins <= 0 || !Array.isArray(meal.shift_kind)) continue;
        for (const shiftKindId of meal.shift_kind) {
          const currentMins = map.get(shiftKindId) || 0;
          map.set(shiftKindId, currentMins + mins);
        }
      }
    }
  } catch (err) {
    console.error("Error fetching staff.meal for shift schedule:", err);
  }
  cachedMealConsumptionMap = map;
  return cachedMealConsumptionMap;
}

let holidaysCache = null;

export async function fetchHolidays() {
  if (holidaysCache !== null) return holidaysCache;
  const set = new Set();
  try {
    const { data } = await proxy.search("staff.holidays", [], ["holiday"]);
    if (data && Array.isArray(data)) {
      for (const rec of data) {
        if (rec?.holiday) set.add(rec.holiday);
      }
    }
  } catch (err) {
    console.error("Error fetching staff.holidays:", err);
  }
  holidaysCache = set;
  return holidaysCache;
}
